import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./TasksUIHelpers";

const TasksUIContext = createContext();

export function useTasksUIContext() {
  return useContext(TasksUIContext);
}

export const TasksUIConsumer = TasksUIContext.Consumer;

export function TasksUIProvider({ TasksUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openEditProductPage: TasksUIEvents?.openEditProductPage,
    openDeleteProductDialog: TasksUIEvents?.openDeleteProductDialog,
    openDeleteTasksDialog: TasksUIEvents?.openDeleteTasksDialog,
    openFetchTasksDialog: TasksUIEvents?.openFetchTasksDialog,
    openUpdateTasksStatusDialog: TasksUIEvents?.openUpdateTasksStatusDialog,
  };

  return (
    <TasksUIContext.Provider value={value}>{children}</TasksUIContext.Provider>
  );
}
